/*
 * Modele utilisé pour pour le fait d'offrir un article à qqn, de vérifier si un article est offrable et vérifier si
 * un utilisateur à des articles qui lui sont offert  (pour afficher les modal adapatés)
 */
(function ($, Global) {
    function OffrirArticleModel() {
        // Déclaration class objet
    }

	OffrirArticleModel.prototype.offer = function (data,$form,  callback) {
		$.ajaxPost('/ajax/articleoffert/offrir', data,$form)
			.done(function (result) {

                if (result.isSuccess) {
                    callback(result);
                } else {
                    Global.ajaxCallback({
                        results: result,
                        form: $form
                    });
                }
            });
	}

    OffrirArticleModel.prototype.checkArticleOffertUser = function ( email,callback) {
        $.ajaxPostRaw('/ajax/articleoffert/checkpending', "\""+email+"\"")
            .done(function (result) {
                callback(result);
            });
    }

    Global.OffrirArticleModel = OffrirArticleModel;
}(jQuery, window));